export const LinkedInIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3"
                y="3"
                width="18"
                height="18"
                rx="3"
                stroke={activeColor}
                strokeWidth="2"
            />

            <path
                d="M8 10V16"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />

            <path
                d="M8 8H8.01"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />

            <path
                d="M12 16V13C12 11.9 12.9 11 14 11C15.1 11 16 11.9 16 13V16"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M12 13V10"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}